import { ComponentProps } from "react";
import { Field, FieldDescription, FieldLabel } from "../ui/field";
import { DebounceProps, FieldErrors, FieldProps } from "./field";
import { Textarea } from "../ui/textarea";
import { TextareaDebounced } from "../inputs/textarea-debounced";

/*
 * TextareaField provices a single component
 * wrapping shadcn/ui Field components
 * to collect input.
 */
export function TextareaField({
  label,
  description,
  errors,
  fieldProps,
  debounce,
  delay,
  ...props
}: React.ComponentProps<"textarea"> & FieldProps & DebounceProps) {
  return (
    <Field {...fieldProps}>
      {label && <FieldLabel>{label}</FieldLabel>}
      <TextareaDebounceSwitch
        aria-invalid={errors && errors.length > 0}
        debounce={debounce}
        delay={delay}
        {...props}
      />
      {description && <FieldDescription>{description}</FieldDescription>}
      <FieldErrors errors={errors} />
    </Field>
  );
}

/**
 * TextareaDebounceSwitch renders the textarea of a field, debounced by default.
 * See {@link FieldInput} for the `debounce` semantics.
 */
function TextareaDebounceSwitch({
  debounce = true,
  delay,
  ...props
}: ComponentProps<"textarea"> & DebounceProps) {
  if (!debounce) {
    return <Textarea {...props} />;
  }

  return <TextareaDebounced delay={delay} {...props} />;
}
